<span
  *ngIf="interactionDate"
  class="date-label interaction-green"
  [ngClass]="{ 'warning-amber': warningLevel == 1, 'warning-red': warningLevel == 2 }"
>
  {{ interactionDate | date : 'EEE dd MMM HH:mm' }}
</span>
